import { ButtonGroup } from '@material-ui/core'
import { LocalizedButton } from 'components/Localization/LocalizedButton'
import { AddWorkingStepButton } from 'components/ProjectPage/BillOfMaterials/Rows/Components/RowWorkingSteps/WorkingSteps/BomWorkingStepsList'
import { BomItemCuttingPlans } from 'features/BillOfMaterials/components/BomItemCuttingPlans'
import { BomItemIssues } from 'features/BillOfMaterials/components/BomItemIssues'
import { BomItemManufacturableButton } from 'features/BillOfMaterials/components/BomItemManufacturableButton'
import { BomItemName } from 'features/BillOfMaterials/components/BomItemName'
import {
  BomItemPricePerBatch,
  useBomItemPricePerBatchStyles,
} from 'features/BillOfMaterials/components/BomItemPricePerBatch'
import { BomItemQuantity } from 'features/BillOfMaterials/components/BomItemQuantity'
import { RowThumbnailButton } from 'features/BillOfMaterials/components/BomItemThumbnailButton'
import { BomItemTotal } from 'features/BillOfMaterials/components/BomItemTotal'
import { BomItemTotalPrice } from 'features/BillOfMaterials/components/BomItemTotalPrice'
import { CommentTooltip } from 'features/BillOfMaterials/components/CommentForm/CommentTooltip'
import { PartTypeArticleSelectorButton } from 'features/BillOfMaterials/PartType/PartTypeArticleSelectorButton'
import { PartTypeDimensionSummary } from 'features/BillOfMaterials/PartType/PartTypeDimensionSummary'
import { PartTypeFileName } from 'features/BillOfMaterials/PartType/PartTypeFileName'
import { PartTypeMenuButton } from 'features/BillOfMaterials/PartType/PartTypeMenuButton'
import { PurchasingItemButton } from 'features/BillOfMaterials/PartType/PurchasingItemButton'
import { BomItemRoutingData } from 'features/BillOfMaterials/RoutingHeader/RoutingData'
import { BomItemMaterialKeywordInput } from 'features/BillOfMaterials/store/components/BomItemMaterialKeywordInput'
import { newProjectActions } from 'features/BillOfMaterials/store/newProjectReducer'
import { SolveWorkingStepNotAvailableButton } from 'features/BillOfMaterials/WorkingSteps/SolveNotAvailableWorkingStepButton'
// import { projectSelectors } from 'features/BillOfMaterials/store/selectors/projectSelectors'
import { BoMItemType } from 'model/Project/BoMItemRow'
import { useAppSelector } from 'store/configureStore'
import { useAppDispatch } from 'store/configureStore'
import { RootAppState } from 'store/configureStore'
import { ProjectViews } from 'store/UI/UITypes'
import { useBomItemDetailsDrawerStyles } from '../BomItemDetailsDrawer.styles'
import { BomItemTargetPriceInput } from '../Inputs/BomItemTargetPriceInput'
import { BomItemPriceContainer } from './BomItemPriceContainer'
import { BomItemDetailsProps } from './ProjectDetails/ProjectDetails'

export const PartTypeDetails = (props: BomItemDetailsProps) => {
  const sharedClasses = useBomItemDetailsDrawerStyles()
  const priceClasses = useBomItemPricePerBatchStyles({ fullWidth: false })

  const dispatch = useAppDispatch()

  const currentView = useAppSelector(
    (state: RootAppState) => state.project.currentView
  )

  // const rowNumber = useAppSelector(
  //   projectSelectors.bomItemRowNumberSelector(props.bomItemId)
  // )

  return (
    <>
      <div className={sharedClasses.bomItemDescription}>
        <RowThumbnailButton
          bomItemType={props.bomItemType}
          rowId={props.bomItemId}
          size="large"
          pictureClassName={sharedClasses.picture}
        />
        <div className={sharedClasses.description}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: '1em',
              alignItems: 'center',
            }}
          >
            <BomItemName
              bomItemId={props.bomItemId}
              label
              valueLabelProps={{
                label: '',
                valueProps: {
                  variant: 'h6',
                },
              }}
            />
            <PurchasingItemButton bomItemId={props.bomItemId} />
            <CommentTooltip
              bomItemId={props.bomItemId}
              bomItemType={props.bomItemType}
            />
            <PartTypeMenuButton bomItemId={props.bomItemId} />
          </div>
          <div className={sharedClasses.prices}>
            <>
              <BomItemTargetPriceInput
                bomItemId={props.bomItemId}
                priceScope={'perUnit'}
                disableSlider
                textFieldProps={{
                  className: priceClasses.moneyTextField,
                  inputProps: {
                    style: {
                      textAlign: 'right',
                      width: '90px',
                    },
                  },
                }}
              />

              <BomItemQuantity
                bomItemId={props.bomItemId}
                translationKey={
                  props.bomItemType === BoMItemType.row
                    ? 'common:quantity'
                    : 'project:batch-size'
                }
              />
              <BomItemTotal bomItemId={props.bomItemId} />

              <BomItemPricePerBatch
                bomItemId={props.bomItemId}
                valueLabelProps={{
                  isLeftAligned: true,
                }}
              />

              <BomItemTotalPrice bomItemId={props.bomItemId} />
            </>
          </div>
        </div>
      </div>
      <div style={{ textAlign: 'right' }}>
        <PartTypeFileName bomItemId={props.bomItemId} />
        <PartTypeDimensionSummary bomItemId={props.bomItemId} />
      </div>
      <div className={sharedClasses.unitSelector}>
        <BomItemManufacturableButton bomItemId={props.bomItemId} />
      </div>
      <div className={sharedClasses.partTypeInfo}>
        <BomItemIssues
          bomItemId={props.bomItemId}
          ulClassName={sharedClasses.bomItemIssues}
        />
        <div className={sharedClasses.materialKeywords}>
          <BomItemMaterialKeywordInput bomItemId={props.bomItemId} />
          <PartTypeArticleSelectorButton
            partTypeId={props.bomItemId}
            variant="partTypeView"
          />
        </div>
        <SolveWorkingStepNotAvailableButton bomItemId={props.bomItemId} />

        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            paddingRight: '8px',
          }}
        >
          <div className={sharedClasses.workingSteps}>
            <AddWorkingStepButton
              bomItemType={BoMItemType.row}
              rowIds={[props.bomItemId]}
            />
            <BomItemRoutingData
              bomItemId={props.bomItemId}
              rootClassName={sharedClasses.workingStepsRouteIcons}
            />
          </div>
        </div>
      </div>
      <BomItemPriceContainer
        bomItemId={props.bomItemId}
        bomItemType={props.bomItemType}
      />

      <BomItemCuttingPlans bomItemId={props.bomItemId} />
      <div className={sharedClasses.bottomBar}>
        <ButtonGroup fullWidth>
          <LocalizedButton
            translationKey="project:BoM-tab-flat"
            variant={
              currentView === ProjectViews.SalesView ? 'contained' : 'outlined'
            }
            color="primary"
            onClick={() =>
              dispatch(
                newProjectActions.changeProjectView(ProjectViews.SalesView)
              )
            }
          />
          {/* <LocalizedButton
          translationKey="project:BoM-tab-hierarchy"
          variant={
            currentView === ProjectViews.AssemblyHierarchy
              ? 'contained'
              : 'outlined'
          }
          color="primary"
          onClick={() => {
            dispatch(
              newProjectActions.setBomItemInSearchByRowNumber({
                rowNumber,
                searchInTreeView: true,
              })
            )
            dispatch(
              newProjectActions.changeProjectView(
                ProjectViews.AssemblyHierarchy
              )
            )
          }}
        /> */}
          <LocalizedButton
            translationKey="project:BoM-tab-routes"
            variant={
              currentView === ProjectViews.RoutesView ? 'contained' : 'outlined'
            }
            color="primary"
            onClick={() =>
              dispatch(
                newProjectActions.changeProjectView(ProjectViews.RoutesView)
              )
            }
          />
          <LocalizedButton
            translationKey="project:BoM-tab-raw-material"
            variant={
              currentView === ProjectViews.PurchaseView
                ? 'contained'
                : 'outlined'
            }
            color="primary"
            onClick={() => {
              dispatch(
                newProjectActions.changeProjectView(ProjectViews.PurchaseView)
              )
            }}
          />
        </ButtonGroup>
      </div>
    </>
  )
}
